import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=56aa8af0&scoped=true&"
import script from "./ImagePreview.vue?vue&type=script&lang=js&"
export * from "./ImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=56aa8af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa8af0",
  null
  
)

export default component.exports